export const textInputProps = {
  rounded: true,
  filled: true,
  dense: true,
  dark: true,
  'background-color': 'surface',
  color: 'secondary',
}
